<template>
  <el-dialog title="Create a survey" :visible.sync="open" :before-close="close" width="390px">
    <div v-if="ready" class="flex flex-wrap mb-6">
      <div class="w-full mb-6">
        <label for="name" class="mb-2 font-bold block">Name</label>
        <input
          class="py-2 px-4 block w-full bg-gray-100 border border-gray-100 rounded focus:outline-none focus:bg-white focus:border-gray-500"
          :class="{'border-red-500': fieldsError.name ? true : false}" id="name" v-model="fields.name" type="text"
          placeholder="Welcome tour" required />
        <p v-if="fieldsError.name" class="text-red-500 font-bold">{{fieldsError.name}}</p>
      </div>

      <div class="w-full mb-6">
        <label for="url_start" class="mb-2 font-bold block">Start building this survey on</label>
        <input
          class="py-2 px-4 block w-full bg-gray-100 border border-gray-100 rounded focus:outline-none focus:bg-white focus:border-gray-500"
          :class="{'border-red-500': fieldsError.name ? true : false}" id="url_start" v-on:blur="checkGoodDomain()"
          v-model="fields.url" type="text" :placeholder="_extractHostname(site.url)" required />
        <p v-if="fieldsError.url" class="text-red-500 font-bold">{{fieldsError.url}}</p>
      </div>
    </div>
    <div class="flex flex-row-reverse">
      <button @click="save()" class="loader-button px-4 py-2 rounded bg-yellow-500 text-blue-50 max-w-max shadow-sm hover:shadow-md">
        <img v-if="loading" src="../../../../assets/img/loading.gif" alt="Loading" />
        Let's go !
      </button>
      <button @click="close"
        class="px-4 py-2 rounded border border-gray-200 text-gray-500 max-w-max shadow-sm hover:shadow-md mr-3">
        Cancel
      </button>
    </div>
  </el-dialog>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: "FormSurvey",
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      ready: false,
      fields: {
        name: null,
        url: null,
      },
      fieldsError: {
        name: null,
        url: null,
      },
      saving: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("account", {
      site: "currentSite"
    })
  },
  methods: {
    ...mapActions("surveys", ["addSurvey"]),
    save() {
      this.fieldsError.name = null;
      this.fieldsError.url = null;
      if (!this.checkInputs()) {
        return false;
      }
      this.saving = true;
      this.loading = true;
      this.addSurvey({
          ...this.fields,
          status: "disable",
          url_target_list: ['.*'],
          url_exclude_list: [],
          target_audience: "all",
          excluded_audience: "none",
        }
      ).then(async (survey) => {
        this.$notify({
          title: "Success",
          message: this.$root.$t("notifications.survey.added"),
          type: "success"
        });
        this.close();
        this.$router.push({
          name: "Survey",
          params: { site: this.$route.params.site, id: survey.id },
        });
        this.loading = false;
      })
        .catch((response) => {
          console.log("error", response);
          this.$notify.error({
            title: this.$root.$t("api." + response.data.code + ".title"),
            message: this.$root.$t("api." + response.data.code + ".message")
          });
          this.saving = false;
          this.loading = false;
        });
    },
    checkGoodDomain() {
      if (this.fields.url && this.fields.url.startsWith("https://")) {
        this.fields.url = this.fields.url.slice(8);
      }
      if (this.fields.url && this.fields.url.startsWith("http://")) {
        this.fields.url = this.fields.url.slice(7);
      }
      if (this.fields.url && this.fields.url.endsWith("/")) {
        this.fields.url = this.fields.url.slice(0, -1);
      }
      let i = 0;
      while (this.fields.url && this.fields.url[i] !== "/" && i <= this.fields.url.length) {
        ++i;
      }
      if (this.fields.url) {
        this.fields.url = this.fields.url.slice(0, i);
      }
    },
    // eslint-disable-next-line
    checkInputs() {
      this.checkGoodDomain();
      const ValidHostnameRegex = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;
      let error = false;
      if (!this.fields.name) {
        this.fieldsError.name = "Name must be a valid string, like: Welcome dear !";
        error = true;
      }
      if (!this.fields.url || !Array.isArray(this.fields.url.match(ValidHostnameRegex)) || (Array.isArray(this.fields.url.match(ValidHostnameRegex)) && !this.fields.url.match(ValidHostnameRegex).length)) {
        this.fieldsError.url = "Hostname must be a valid string, like: rocketfid.com";
        error = true;
      }
      return !error;
    },
    close() {
      this.$emit("close", true);
    }
  },
  mounted() {
    this.ready = true;
  },
}
</script>

<style>
.loader-button {
  display: flex;
  align-items: center;
}

.loader-button img {
  margin-right: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/surveys/ui/modal/create.vue